import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initMetaPixel } from './lib/metaPixel';

// Suppress browser extension message channel errors (non-critical)
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('message channel closed before a response was received')) {
    event.preventDefault();
    console.warn('Browser extension message channel error suppressed:', event.message);
  }
});

// Also catch unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('message channel closed before a response was received')) {
    event.preventDefault();
    console.warn('Browser extension promise rejection suppressed:', event.reason.message);
  }
});

// Initialize Meta Pixel (no-op unless REACT_APP_META_PIXEL_ID is set).
initMetaPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);